const sliderQueryLoopMovil = () => {
	const slider = document.querySelector(".off-zoo__template");

	if (!slider || !window.jQuery) return;

	const $slider = jQuery(slider);

	const handleSlider = () => {
		if (window.innerWidth < 992) {
			if (!$slider.hasClass("slick-initialized")) {
				$slider.slick({
					slidesToShow: 2,
					slidesToScroll: 1,
					arrows: true,
					prevArrow: '<button type="button" class="slick-prev" aria-label="Anterior"></button>',
					nextArrow: '<button type="button" class="slick-next" aria-label="Siguiente"></button>',
					dots: false,
					infinite: true,
					autoplay: false,
					speed: 600,
					centerMode: false,
					adaptiveHeight: false,
					responsive: [
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 1,
								slidesToScroll: 1,
								centerMode: true,
								centerPadding: "20px",
							},
						},
					],
				});
			}
		} else {
			if ($slider.hasClass("slick-initialized")) {
				$slider.slick("unslick");
			}
		}
	};

	handleSlider();

	let resizeTimeout;

	window.addEventListener("resize", () => {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(handleSlider, 150);
	});
};

export { sliderQueryLoopMovil };
